export default {
  data: () => ({
    translations: {
      total_points: {
        el: 'ΣΥΝΟΛΟ ΠΟΝΤΩΝ',
        en: 'TOTAL POINTS',
        it: 'PUNTI TOTALI',
      },
      total_cashback: {
        el: 'ΣΥΝΟΛΟ CASHBACK',
        en: 'TOTAL CASHBACK',
        it: 'CASHBACK TOTALE',
      },
      availableCoupons: {
        el: 'Έχετε διαθέσιμα κουπόνια για εξαργύρωση!',
        en: 'You have available coupons for redemption!',
        it: 'Hai a disposizione dei coupon da riscuotere!',
      },
    },
  }),
};
